module.exports = __webpack_public_path__ + "images/landing/banner/help-img-8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-8.png
// module id = 2wXK
// module chunks = 55